import { CALL_BB_API } from '../api/browsboxApi';
import { MEDIA_SCHEMA } from '../api/schema';
import { ROUTE_MEDIA, ROUTE_MEDIA_UPLOAD, ROUTE_MEDIA_CROP, ROUTE_MEDIA_FILE } from '../api/routes';
import { buildRoute } from '../api';

export const MEDIA_REQUEST = 'MEDIA_REQUEST';
export const MEDIA_SUCCESS = 'MEDIA_SUCCESS';
export const MEDIA_FAILURE = 'MEDIA_FAILURE';

// BrowsBox API middleware.
const fetchMedia = () => ({
  [CALL_BB_API]: {
    types: [MEDIA_REQUEST, MEDIA_SUCCESS, MEDIA_FAILURE],
    endpoint: ROUTE_MEDIA,
    method: 'GET',
    schema: MEDIA_SCHEMA,
  },
});

// Redux Thunk middleware.
export const loadMedia = () => dispatch => dispatch(fetchMedia());

export const MEDIA_UPLOAD_REQUEST = 'MEDIA_UPLOAD_REQUEST';
export const MEDIA_UPLOAD_SUCCESS = 'MEDIA_UPLOAD_SUCCESS';
export const MEDIA_UPLOAD_FAILURE = 'MEDIA_UPLOAD_FAILURE';

// BrowsBox API middleware.
const postUploadMedia = (file, options = {}, metadata = {}) => ({
  [CALL_BB_API]: {
    types: [MEDIA_UPLOAD_REQUEST, MEDIA_UPLOAD_SUCCESS, MEDIA_UPLOAD_FAILURE],
    endpoint: ROUTE_MEDIA_UPLOAD,
    method: 'POST:FORM',
    json: { file },
    options,
  },
  metadata,
});

// Redux Thunk middleware.
export const uploadMedia = (file, options, metadata) => dispatch => dispatch(postUploadMedia(file, options, metadata));

export const MEDIA_CROP_REQUEST = 'MEDIA_CROP_REQUEST';
export const MEDIA_CROP_SUCCESS = 'MEDIA_CROP_SUCCESS';
export const MEDIA_CROP_FAILURE = 'MEDIA_CROP_FAILURE';

// BrowsBox API middleware.
const postCropMedia = (value) => {
  const { id, ...options } = value;
  const endpoint = buildRoute(ROUTE_MEDIA_CROP, { id });
  return {
    [CALL_BB_API]: {
      types: [MEDIA_CROP_REQUEST, MEDIA_CROP_SUCCESS, MEDIA_CROP_FAILURE],
      endpoint,
      method: 'PATCH',
      json: {
        ...options,
      },
    },
  };
};

// Redux Thunk middleware.
export const cropMedia = value => dispatch => dispatch(postCropMedia(value));

export const MEDIA_FILE_REQUEST = 'MEDIA_FILE_REQUEST';
export const MEDIA_FILE_SUCCESS = 'MEDIA_FILE_SUCCESS';
export const MEDIA_FILE_FAILURE = 'MEDIA_FILE_FAILURE';

// BrowsBox API middleware.
const getMediaCall = (value) => {
  const { id } = value;
  const endpoint = buildRoute(ROUTE_MEDIA_FILE, { id });
  return {
    [CALL_BB_API]: {
      types: [MEDIA_FILE_REQUEST, MEDIA_FILE_SUCCESS, MEDIA_FILE_FAILURE],
      endpoint,
      method: 'GET',
    },
  };
};

// Redux Thunk middleware.
export const getMedia = value => dispatch => dispatch(getMediaCall(value));

export const MEDIA_UPLOAD_FILE_START = 'MEDIA_UPLOAD_FILE_START';
export const startUploadFile = (file, uniqId) => ({
  type: MEDIA_UPLOAD_FILE_START,
  value: {
    file,
    uniqId,
  },
});

export const MEDIA_UPDATE_UPLOAD_PROGRESS = 'MEDIA_UPDATE_UPLOAD_PROGRESS';
export const updateUploadProgress = (file, progress, uniqId) => ({
  type: MEDIA_UPDATE_UPLOAD_PROGRESS,
  value: {
    file,
    progress,
    uniqId,
  },
});

export const MEDIA_UPLOAD_ERROR = 'MEDIA_UPLOAD_ERROR';
export const mediaUploadError = (uniqId, message) => ({
  type: MEDIA_UPLOAD_ERROR,
  value: {
    message,
    uniqId,
  },
});

export const MEDIA_REMOVE_UPLOAD_ITEM = 'MEDIA_REMOVE_UPLOAD_ITEM';
export const mediaRemoveUploadedItem = uniqId => ({
  type: MEDIA_REMOVE_UPLOAD_ITEM,
  value: {
    uniqId,
  },
});

export const MEDIA_LIBRARY_RESET_STATE = 'MEDIA_LIBRARY_RESET_STATE';
export const mediaLibraryResetState = () => ({
  type: MEDIA_LIBRARY_RESET_STATE,
});

export const MEDIA_LIBRARY_SET_PAGE = 'MEDIA_LIBRARY_SET_PAGE';
export const mediaLibrarySetPage = page => ({
  type: MEDIA_LIBRARY_SET_PAGE,
  value: {
    page,
  },
});

export const MEDIA_LIBRARY_INCREASE_PAGE = 'MEDIA_LIBRARY_INCREASE_PAGE';
export const mediaLibraryIncreasePage = () => ({
  type: MEDIA_LIBRARY_INCREASE_PAGE,
});

export const MEDIA_LIBRARY_SET_SEARCH_PHRASE = 'MEDIA_LIBRARY_SET_SEARCH_PHRASE';
export const mediaLibrarySetSearchPhrase = phrase => ({
  type: MEDIA_LIBRARY_SET_SEARCH_PHRASE,
  value: {
    phrase,
  },
});



// WEBPACK FOOTER //
// ./src/actions/media.js